import { SET_PRODUCTS, SET_PRODUCT } from "../../mutations.type";

export default {
  [SET_PRODUCTS](state, products) {
    state.products = products;
  },
  [SET_PRODUCT](state, product) {
    state.product = product;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/product/mutations.js